import dotProp from 'dot-prop-immutable'
import * as actions from '../actionTypes'
import defaultTheme from '../theme'
import { fetchObjectFromStorage, setObjectInStorage } from '../api/utils'

const setTheme = (userTheme) => {
  //Merge theme settings
  const sessionTheme = {...defaultTheme, ...userTheme}

  //Merge palettes
  sessionTheme.palette = {...defaultTheme.palette, ...userTheme.palette}

  setObjectInStorage('sessionTheme', sessionTheme)

  return sessionTheme
}

const initialState = {
  admin: {
    name: '',
    email: '',
    phone: ''
  },
  lang: '', // will default to 'en' via i18n config
  sessionLang: null,
  supportedLanguages: {
    languages: [],
    isRequesting: false,
    errors: false
  },
  theme: fetchObjectFromStorage('sessionTheme') || defaultTheme,
  organizationId: null,
  organizationName: '',
  logo: fetchObjectFromStorage('sessionLogo') || {
    logoFile: null,
    logoText: null
  }
}

const globalSettings = (state = initialState, action) => {
  switch(action.type) {
    case actions.APPLY_LANGUAGE:
      return { ...state, lang: action.payload.lang }
    case actions.APPLY_SESSION_LANGUAGE:
      return { ...state, sessionLang: action.payload }
    case actions.THEME_REQUESTED_SUCCESS:
      // default admin to empty object while api does not support admin props
      const {theme, logo, organizationName, admin={}} = action.payload

      const sessionTheme = setTheme(theme)

      setObjectInStorage('sessionLogo', logo)

      return {
        ...state,
        admin,
        organizationName,
        logo,
        theme: sessionTheme,
      }
    case actions.THEME_REQUESTED_FAILURE:
      // pass thru, use default theme
      return state
    case actions.SUPPORTED_LANG_REQUESTED:
      return dotProp.set(state, 'supportedLanguages.isRequesting', true)
    case actions.SUPPORTED_LANG_SUCCESS:
      state = dotProp.set(state, 'supportedLanguages.languages', action.payload)
      return dotProp.set(state, 'supportedLanguages.isRequesting', false)
    case actions.SUPPORTED_LANG_FAILURE:
        state = dotProp.merge(state, 'supportedLanguages.errors', action.payload)
      return dotProp.set(state, 'supportedLanguages.isRequsting', false)
    default:
      return state
  }
}

export default globalSettings




// WEBPACK FOOTER //
// ./src/reducers/global-settings.js